import React from "react";
import { MicrositeHeading } from "pages/LayoutComponents/MicrositeHeading";
import { ResourceCard } from "../../UniFiPartnerHub.types";
import * as S from "./Resources.styles";
import { useTranslation } from "hooks/useTranslation";

import chevronSvg from "../../assets/icons/chevron.svg";

export const Resources = ({ resources }: { resources: ResourceCard[] }) => {
  const { t } = useTranslation();
  return (
    <>
      <MicrositeHeading
        title={t("unifiPartnerHub.resources.title")}
        isCentered
        spacing={{ top: 64 }}
      />
      <S.CardContainer>
        {resources.map((resource, index) => (
          <S.Card key={`${resource.title}-${index}`}>
            <S.StyleableSvgImage src={resource.icon} width={48} height={48} />
            <S.Title>{resource.title}</S.Title>
            <S.LinkContainer href={resource.link.href}>
              {resource.link.text}
              <S.StyleableSvgImage
                src={chevronSvg}
                width={20}
                height={20}
              />
            </S.LinkContainer>
          </S.Card>
        ))}
      </S.CardContainer>
    </>
  );
};
